module.exports = __webpack_public_path__ + "img/card-top-deco.e8991798.png";